import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { RiSlideshow2Line } from 'react-icons/ri';
import { FaRegListAlt, FaUsers } from 'react-icons/fa';
import { MdOutlinePayment, MdRealEstateAgent } from 'react-icons/md';
import { BsQuestionOctagon } from 'react-icons/bs';
import { HiOutlineViewGridAdd } from 'react-icons/hi';

const SideBar = ({ toggleNav }) => {

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  return (
    <div id="side-bar" className={toggleNav ? "slide" : "" }>
      <div className="nav-wrap">
        {userInfo?.role === "admin" && 
          <>
            <NavLink to="/all-agents" activeclassname="active">
              <FaUsers size={25} />
              <span>All Agents</span>
            </NavLink>
            <NavLink to="/properties" activeclassname="active">
              <MdRealEstateAgent size={25} />
              <span>Properties</span>
            </NavLink>
            {/* <NavLink to="/subscriptions" activeclassname="active">
              <MdOutlinePayment size={25} />
              <span>Subscriptions</span>
            </NavLink> */}
            <NavLink to="/requests" activeclassname="active">
              <BsQuestionOctagon size={25} />
              <span>View Requests</span>
            </NavLink>
          </>
        }
        {userInfo?.role === "estate-agent" && 
          <>
            <NavLink to="/add-property" activeclassname="active">
              <HiOutlineViewGridAdd size={25} />
              <span>Post Property</span>
            </NavLink>
            <NavLink to="/my-listing" activeclassname="active">
              <FaRegListAlt size={25} />
              <span>My Listing</span>
            </NavLink>
            {/* <NavLink to="/plans" activeclassname="active">
              <MdOutlinePayment size={25} />
              <span>Subscription</span>
            </NavLink> */}
            {/* <NavLink to="/dashboard" activeclassname="active">
              <RiSlideshow2Line size={25} />
              <span>Banner Adverts</span>
            </NavLink> */}
          </>
        }
      </div>
    </div>
  )
}

export default SideBar;